import path from 'path';
import history from '../myHistory';
import { addGroupMemberEventRegIdToUrl, urlStrippedRetryAttempt, addRetryAttempt } from '../utils/registrationUtils';

export const SET_CURRENT_PAGE = 'event-guestside-site/pathInfo/SET_CURRENT_PAGE';
export const SET_NAVIGATION_DIALOG_CONFIG = 'event-guestside-site/pathInfo/SET_NAVIGATION_DIALOG_CONFIG';

import Logger from '@cvent/nucleus-logging';
const LOG = new Logger('event-guestside-site/src/redux/actions/pathInfo');

export function getPagePath(state, pageId) {
  const { pathInfo: { rootPath } } = state;
  let newPath = path.join(rootPath, pageId);
  if (global.location.search) {
    newPath = newPath + global.location.search;
  }
  LOG.debug(`path for ${pageId} is ${newPath}`);
  return newPath;
}

export function routeToUrl(url) {
  return () => {
    history.push(url);
  };
}

export function routeToPage(pageId) {
  return (dispatch, getState) => {
    history.push(getPagePath(getState(), pageId));
  };
}

export function routeToHomePage() {
  return (dispatch, getState) => {
    history.push(getPagePath(getState(), ''));
  };
}

export function routeToFirstPageOfRegistrationForGroup(currentEventRegistrationId = '',
  firstPageId = 'regProcessStep1') {
  return (dispatch, getState) => {
    history.push(addGroupMemberEventRegIdToUrl(getPagePath(getState(), firstPageId), currentEventRegistrationId),
      false);
  };
}

/**
 * A browser redirect and restart the SPA
 * Note this kills the running app, and any unsaved state change is lost.
 */
export function redirectToPage(pageId) {
  return (dispatch, getState) => {
    global.location.replace(getPagePath(getState(), pageId));
  };
}

/**
 * Takes the current uri, strips off the retry attempt querystring if present,
 * and replaces the current history entry with the new uri.
 */
export function stripRetryAttempt() {
  history.replace(urlStrippedRetryAttempt(global.location.toString()));
}

/**
 * Attempt to reload and restart the SPA using the same page it's currently on.
 * Note this kills the running app, and any unsaved state change is lost.
 */
export function retryLoadPage() {
  global.location.replace(addRetryAttempt(global.location.toString()));
}

/**
 * Sets the current page within the reducer.
 * @param {string} pageId - The id of the page to set as the current page.
 */
export function setCurrentPage(pageId) {
  return {
    type: SET_CURRENT_PAGE,
    payload: {
      pageId
    }
  };
}

/**
 * Sets the current page within the reducer.
 * @param {object} config - The config for the navigation dialog.
 */
export function setNavigationDialogConfig(config) {
  return {
    type: SET_NAVIGATION_DIALOG_CONFIG,
    payload: config
  };
}

/**
 * Retrieves the id of the page the application is currently on.
 */
export function getCurrentPageId(state) {
  return state.pathInfo.currentPageId;
}

const initialState = {
  rootPath: '',
  eventId: '',
  currentPageId: '',
  navigationDialogConfig: {
    isOpen: false
  }
};

/**
 * Reducer managing the information describing the path the application is currently at.
 */
export default function reducer(state = initialState, action) {
  const payload = action.payload || {};
  switch (action.type) {
    case SET_CURRENT_PAGE: {
      return {
        ...state,
        currentPageId: payload.pageId
      };
    }
    case SET_NAVIGATION_DIALOG_CONFIG: {
      return {
        ...state,
        navigationDialogConfig: payload
      };
    }
    default: return state;
  }
}
